export const GET_FILES = 'GET_FILES';
export const UPLOAD_FILE = 'UPLOAD_FILE';
export const DUPLICATE_FILE = 'DUPLICATE_FILE';
export const SET_FILE = 'SET_FILE';
export const GET_TOKEN = 'GET_TOKEN';
export const SET_TOKEN = 'SET_TOKEN';
export const ADD_SUCCEEDED_FILE = 'ADD_SUCCEEDED_FILE';